import { render, staticRenderFns } from "./root.vue?vue&type=template&id=591c3e2c&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
import style0 from "./root.vue?vue&type=style&index=0&id=591c3e2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c3e2c",
  null
  
)

export default component.exports